window.addEventListener("DOMContentLoaded", () => {
    let announcementBar = document.querySelector("#shopify-section-announcement-bar");

    if (announcementBar) {
        const announcementWrapper = document.querySelector('.announcement-bar__outer')
        new Swiper(announcementWrapper, {
            slidesPerView: 1,
            speed: 800,
            spaceBetween: 0,
            autoplay: announcementWrapper.classList.contains("autoplay") || false,
            loop: true,
          autoHeight: true
        });
    }
});
